import {ContentPoster} from '../../model/content-poster.model';
import * as PosterActions from '../actions/posters-without-catchup.actions';

export type Actions = PosterActions.Actions;

const initialState: ContentPoster = {
  id: 0,
  posterDefinition: null,
  url: null,
};

export function postersWithoutCatchupReducer(state: ContentPoster[] = [], action: Actions) {
  switch (action.type) {
    case PosterActions.SET_POSTER:
      return [...state, action.payload];
    case PosterActions.REMOVE_POSTER:
      return state.filter((poster) => poster.posterDefinition.id != action.payload);
    case PosterActions.RESET_POSTER:
      return [];
    default:
      return state;
  }
}
